@if (
  {
    staff: staff$ | async,
  };
  as $
) {
  <p-popover
    #opstaff
    styleClass="overflow-hidden text-sm"
    appendTo="body"
    [dismissable]="true"
  >
    <ng-template #content>
      <!-- Dropdown Content -->
      @if ($.staff) {
        <div
          class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2"
        >
          <div class="w-10rem line-height-1">
            <div class="text-sm font-medium text-800">
              {{ $.staff.name | titlecase }}
            </div>
            <div class="text-xs text-600 ml-1 mt-1">{{ $.staff.id }}</div>
          </div>
          <span
            class="bg-green-500 px-2 py-1 font-bold border-round text-white text-xxs uppercase ml-4 mt-1"
            >{{ $.staff.designation }}</span
          >
        </div>
      }
      <!-- Dropdown Content -->
      <!-- Dropdown Footer -->
      @if ($.staff) {
        <div
          class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs"
          edit-profile.component.ts
        >
          <div class="flex align-items-center mb-2">
            <i class="fa fa-phone mr-2 text-500"></i>
            @if ($.staff.mobile_number !== 0) {
              <span>
                {{ $.staff.mobile_country_code }}
                {{ $.staff.mobile_number }}</span
              >
            }
            @if ($.staff.mobile_number === 0) {
              <span>NA</span>
            }
          </div>
          <div class="flex align-items-center mb-1">
            <i class="fa fa-envelope font-light mr-2 text-500"></i>
            <span class="break-word">{{ $.staff.email_id }}</span>
          </div>
        </div>
      }
      <!-- Dropdown Footer -->
    </ng-template>
  </p-popover>
  @if ($.staff) {
    <div class="flex align-items-center">
      <span
        class="flex align-items-center"
        (mouseenter)="opstaff.show($event)"
        (mouseleave)="opstaff.hide($event)"
      >
        @if ($.staff && !$.staff.ff_picture) {
          <p-avatar
            [label]="$.staff.name | titlecase | shortName"
            shape="square"
            styleClass="text-sm"
          />
        }
        @if ($.staff && $.staff.ff_picture) {
          <p-avatar [image]="$.staff.ff_picture" shape="square" />
        }
        <strong class="ml-2 text-primary">{{
          $.staff.name | titlecase
        }}</strong>
      </span>
    </div>
  }
  @if (!$.staff) {
    <div>-</div>
  }
}
